import xlsICON from '../../assets/images/icon-xls.svg';
import React from 'react';
import * as XLSX from 'xlsx';
import dashboardApi from '../../apis/dashboard-api';

export const ExportToExcel = ({ dateFilter }) => {
  const fileExtension = '.xlsx';

  const exportToCSV = (apiData, fileName) => {
    const ws = XLSX.utils.json_to_sheet(apiData);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    XLSX.writeFile(wb, `${fileName ? fileName : 'all'}_${Date.now()}${fileExtension}`);
  };

  const downloadHandler = async () => {
    let dateType = '';
    if (dateFilter.range.startDate && dateFilter.range.endDate) {
      dateType = `${dateFilter.range.startDate},${dateFilter.range.endDate}`;
    }
    const { data } = await dashboardApi.getExportData(dateType);

    if (data.data) {
      exportToCSV(data.data, dateFilter.slug);
    } else {
      alert(data?.message);
    }
  };

  return (
    <button className="xls-export-btn" type="button" onClick={downloadHandler}><img src={xlsICON} alt="Excel" width={20} /> Excel</button>
  );
};